import SystemDialogService from '../../../../shared/services/systemDialogService.js';
import stammdatenService from '../services/stammdatenService.js';
import systemNachrichtService from '../services/systemNachrichtService.js';
import { collectValues, displayArray, neueArrayRow, resetDialogInput } from '../util.js';
import { updateDebounceUnternehmen } from './verwaltung.js';
import { wendeListenSucheAn } from '../listenSuche.js';

window.myHandlers = window.myHandlers || {};
window.myHandlers.confirmNeuerEinsatzortDialog = confirmNeuerEinsatzortDialog;
window.myHandlers.neuerEinsatzort = neuerEinsatzort;
window.myHandlers.speichereEinsatzort = speichereEinsatzort;
window.myHandlers.editEinsatzortKontaktdaten = editEinsatzortKontaktdaten;
window.myHandlers.confirmEinsatzortKontaktdaten = confirmEinsatzortKontaktdaten;
window.myHandlers.editEinsatzortNotiz = editEinsatzortNotiz;
window.myHandlers.confirmEinsatzortNotiz = confirmEinsatzortNotiz;

// Befüllt die Oberfläche der Verwaltung der Einsatzorte pro Betriebstätte
async function ladeEinsatzorte() {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const betriebsstaetten = unternehmen.Betriebsstaette;
	// nur aktive Betriebsstätten anzeigen
	const aktiveBS = betriebsstaetten.filter((bs) => bs.Aktiv === true);
	if (aktiveBS.length === 0) {
		systemNachrichtService.zeigeKleineNachricht('Keine aktiven Betriebsstätten vorhanden!', 0);
		return;
	}
	// reset des leeren container content falls es Betriebsstätten gibt.
	document.querySelector('#eo-empty-message').remove();
    aktiveBS.forEach((bs) => {
		const template = document.querySelector('[eo-panel-template]');
		const newPanel = template.content.cloneNode(true).children[0];
		newPanel.id = `${bs._id}-panel`;
		newPanel.querySelector('[eo-neu-button]').id = bs._id;
		newPanel.querySelector('[eo-button-header]').innerText = `Betriebsstätte: ${`${bs.BetriebsstaetteName} ${!bs.Aktiv ? '(inaktiv)' : ''}`}`;
		document.querySelector('.main-container').appendChild(newPanel);
		displayArray(bs.Einsatzorte, 'eo-', newPanel, bs._id);
		// Indikator setzen, ob bereits Kontaktdaten/Notiz hinterlegt sind
		bs.Einsatzorte.forEach((einsatzort) => {
			const zeile = document.getElementById(`eo-${einsatzort._id}-${bs._id}`);
			if (zeile) {
				setKontaktdatenIndikator(zeile.querySelector('.eo-kontaktdaten-button'), einsatzort);
				setNotizIndikator(zeile.querySelector('.eo-notiz-button'), einsatzort);
			}
		});
	});
	wendeListenSucheAn('eo-');
}

/** Findet den Einsatzort (samt Unternehmensobjekt) anhand seiner Zeile in der Verwaltung. */
async function findeEinsatzortVonZeile(zeile) {
	const [, einsatzortID, bsID] = zeile.id.split('-');
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const betrieb = unternehmen.Betriebsstaette.find((bs) => bs._id === bsID);
	const einsatzort = betrieb?.Einsatzorte.find((eo) => eo._id === einsatzortID);
	return { unternehmen, einsatzort };
}

/** Markiert den Button, falls für den Einsatzort bereits Anschrift/Kontaktdaten hinterlegt sind. */
function setKontaktdatenIndikator(button, einsatzort) {
	if (!button) return;
	const hatKontaktdaten = [einsatzort.Strasse, einsatzort.Hausnummer, einsatzort.PLZ, einsatzort.Ort, einsatzort.Ansprechpartner, einsatzort.Telefon, einsatzort.eMail].some((feld) => feld?.trim());
	button.classList.toggle('has-kontaktdaten', hatKontaktdaten);
	button.querySelector('i').classList.toggle('bi-person-vcard-fill', hatKontaktdaten);
	button.querySelector('i').classList.toggle('bi-person-vcard', !hatKontaktdaten);
	button.title = hatKontaktdaten ? 'Kontaktdaten bearbeiten' : 'Kontaktdaten hinzufügen';
}

function confirmEinsatzortKontaktdaten() {
	SystemDialogService.instance.confirm({
		Strasse: document.getElementById('eo-kontaktdaten-strasse').value,
		Hausnummer: document.getElementById('eo-kontaktdaten-hausnummer').value,
		Adresszusatz: document.getElementById('eo-kontaktdaten-adresszusatz').value,
		PLZ: document.getElementById('eo-kontaktdaten-plz').value,
		Ort: document.getElementById('eo-kontaktdaten-ort').value,
		Ansprechpartner: document.getElementById('eo-kontaktdaten-ansprechpartner').value,
		Telefon: document.getElementById('eo-kontaktdaten-telefon').value,
		eMail: document.getElementById('eo-kontaktdaten-email').value,
	});
}

/** Öffnet einen Dialog, um Anschrift und Kontaktdaten des Einsatzortes zu pflegen. */
async function editEinsatzortKontaktdaten(thisElement) {
	const zeile = thisElement.closest('.eo-zeile');
	const { unternehmen, einsatzort } = await findeEinsatzortVonZeile(zeile);
	if (!einsatzort) return;
	document.getElementById('eo-kontaktdaten-titel').innerText = `Kontaktdaten: ${einsatzort.Bezeichnung}`;
	document.getElementById('eo-kontaktdaten-strasse').value = einsatzort.Strasse || '';
	document.getElementById('eo-kontaktdaten-hausnummer').value = einsatzort.Hausnummer || '';
	document.getElementById('eo-kontaktdaten-adresszusatz').value = einsatzort.Adresszusatz || '';
	document.getElementById('eo-kontaktdaten-plz').value = einsatzort.PLZ || '';
	document.getElementById('eo-kontaktdaten-ort').value = einsatzort.Ort || '';
	document.getElementById('eo-kontaktdaten-ansprechpartner').value = einsatzort.Ansprechpartner || '';
	document.getElementById('eo-kontaktdaten-telefon').value = einsatzort.Telefon || '';
	document.getElementById('eo-kontaktdaten-email').value = einsatzort.eMail || '';
	const input = await SystemDialogService.instance.displayAsync('eo-kontaktdaten-dialog');
	if (!input.success) return;
	// Direkt am gecachten Objekt setzen, damit parallele Zeilen-Speicherungen die Kontaktdaten nicht überschreiben
	Object.assign(einsatzort, input.data);
	updateDebounceUnternehmen(unternehmen);
	setKontaktdatenIndikator(thisElement, einsatzort);
}

/** Markiert den Button, falls für den Einsatzort bereits eine Notiz hinterlegt ist. */
function setNotizIndikator(button, einsatzort) {
	if (!button) return;
	const hatNotiz = !!einsatzort.Notiz?.trim();
	button.classList.toggle('has-notiz', hatNotiz);
	button.title = hatNotiz ? 'Notiz bearbeiten' : 'Notiz hinzufügen';
}

function confirmEinsatzortNotiz() {
	SystemDialogService.instance.confirm({
		Notiz: document.getElementById('eo-notiz-text').value,
	});
}

/** Öffnet einen Dialog, um eine Notiz zum Einsatzort zu pflegen. */
async function editEinsatzortNotiz(thisElement) {
	const zeile = thisElement.closest('.eo-zeile');
	const { unternehmen, einsatzort } = await findeEinsatzortVonZeile(zeile);
	if (!einsatzort) return;
	document.getElementById('eo-notiz-titel').innerText = `Notiz: ${einsatzort.Bezeichnung}`;
	document.getElementById('eo-notiz-text').value = einsatzort.Notiz || '';
	const input = await SystemDialogService.instance.displayAsync('eo-notiz-dialog');
	if (!input.success) return;
	// Direkt am gecachten Objekt setzen, damit parallele Zeilen-Speicherungen die Notiz nicht überschreiben
	einsatzort.Notiz = input.data.Notiz;
	updateDebounceUnternehmen(unternehmen);
	setNotizIndikator(thisElement, einsatzort);
}

function confirmNeuerEinsatzortDialog() {
	SystemDialogService.instance.confirm({
		einsatzort: document.getElementById('neu-einsatzort-name').value,
	});
}

// Click handler für neuen Einsatzort
async function neuerEinsatzort(thisElement) {
	const prefix = 'eo-';
	const bsID = thisElement.id;
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const input = await SystemDialogService.instance.displayAsync('neu-einsatzort-dialog');
	// vermeide leere Einträge oder ungültige Betriebstätte ID
	if (!input.success) {
		return;
	}
	if (input.data.einsatzort === '' || unternehmen.Betriebsstaette.findIndex((bs) => bs._id === bsID) < 0) {
		systemNachrichtService.zeigeKleineNachricht('Abbruch: Keine Bezeichnung angegeben.', '0');
		return;
	}
	// Wir schicken den neuen Bezug an den Server
	const result = await stammdatenService.erstelleEinsatzort(input.data.einsatzort, bsID);
	if (!result) {
		return;
	}
	resetDialogInput('neu-einsatzort-dialog');
	// Aktualisierung der Oberfläche
	const bsPanel = document.getElementById(`${bsID}-panel`);
	const template = bsPanel.querySelector(`[${prefix}template]`);
	// Wir brauchen ein Referenzelement, wo wir die neuen Zeilen im HTML einfügen können
	const referenceElement = bsPanel.querySelector(`[${prefix}button]`);
	neueArrayRow(template, referenceElement, result, prefix, bsID);
	wendeListenSucheAn(prefix);
}

/**
 * Speichert die Änderungen aller Einsatzorte auf einmal, indem die Werte von allen Zeilen gesammelt und an den Server geschickt werden.
 */
async function speichereEinsatzort() {
	let unternehmen = await stammdatenService.holeUnternehmensdaten();
	// Wir benutzen vorsichtshalber eine Kopie, damit wir nicht später Inkonsitenzen bei einem Fehler haben
	unternehmen = JSON.parse(JSON.stringify(unternehmen));
	
	// Sammle Werte von allen Einsatzort-Zeilen
	const allEinsatzortRows = document.querySelectorAll('.eo-zeile:not(.header)');
	
	allEinsatzortRows.forEach((zeile) => {
		// wir brauchen die einsatzortID und betriebsstätteID
		const idParts = zeile.id.split('-');
		const einsatzortID = idParts[1];
		const bsID = idParts[2];
		
		const betrieb = unternehmen.Betriebsstaette.find((bs) => bs._id === bsID);
		if (!betrieb) {
			return;
		}
		const einsatzort = betrieb.Einsatzorte.find((qu) => qu._id === einsatzortID);
		if (!einsatzort) {
			return;
		}
		collectValues(einsatzort, 'eo-', zeile);
	});
	
	updateDebounceUnternehmen(unternehmen);
}

export {
    ladeEinsatzorte,
};